import { cardStyles as fastCardStyles } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
export const foundationCardStyles = (context, definition) => css `
  ${fastCardStyles(context, definition)}
  :host {
    background-color: var(--fui-card-fill-color);
    color: var(--fui-card-foreground-color);
  }
`;
